<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备类型" prop="deviceTypeId">
        <a-select v-model="form.deviceTypeId" placeholder="请选择设备类型" allow-clear>
          <a-select-option v-for="item in deviceTypeOptions" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设备序列号" prop="deviceSn">
        <a-input v-model="form.deviceSn" placeholder="请输入设备序列号" />
      </a-form-model-item>
      <a-form-model-item label="蓝牙MAC地址" prop="bluetoothMac">
        <a-input v-model="form.bluetoothMac" placeholder="请输入蓝牙MAC地址，如 AA:BB:CC:DD:EE:FF" />
      </a-form-model-item>
      <a-form-model-item label="设备图片" prop="deviceImage">
        <file-upload v-model="form.deviceImage" type="image" :count="1" @change="changeDeviceImage" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="3" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDeviceStock, addDeviceStock, updateDeviceStock } from '@/api/mibo/deviceStock'
import { listType } from '@/api/mibo/type'

export default {
  name: 'CreateForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      deviceTypeOptions: [],
      form: {
        id: null,
        deviceTypeId: null,
        deviceSn: null,
        bluetoothMac: null,
        deviceImage: null,
        status: 1,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        deviceTypeId: [
          { required: true, message: '设备类型不能为空', trigger: 'change' }
        ],
        deviceSn: [
          { required: true, message: '设备序列号不能为空', trigger: 'blur' }
        ],
        bluetoothMac: [
          { required: true, message: '蓝牙MAC地址不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadDeviceTypeOptions()
  },
  methods: {
    changeDeviceImage (url) {
      this.form.deviceImage = url
    },
    loadDeviceTypeOptions () {
      listType({ status: 1 }).then(response => {
        this.deviceTypeOptions = response.data || []
      })
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceTypeId: null,
        deviceSn: null,
        bluetoothMac: null,
        deviceImage: null,
        status: 1,
        remark: null
      }
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加设备'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDeviceStock({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改设备'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const request = this.form.id ? updateDeviceStock(this.form) : addDeviceStock(this.form)
        request.then(response => {
          if (response.success) {
            this.$message.success(this.form.id ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          } else {
            this.$message.error(response.message || response.msg || '操作失败')
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
